import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toggleModal, getCurrencySign } from "../../../store/common";
import { getActiveLanguage } from "react-localize-redux";
import { userIsAuthenticated } from "../../../auth";
import { getTranslate } from "react-localize-redux";
import {
  productImagePath,
  createMarkup,
  youtubeVideo,
  hostPath
} from "../../../utils/product.util";
import YouTube from "react-youtube";

class ProductDetailContainer extends Component {
  // somewhere to detail
  // componentDidMount () {
  //   console.log('product detail did mount')
  //   shop.getProductDetail(productDetailFromApi => {
  //     store.dispatch(storeProductDetail(productDetailFromApi))
  //   })
  // }

  // // detail to detail
  // componentWillReceiveProps (nextProps) {
  //   // load product data
  //   if (this.props.params.product !== nextProps.params.product) {
  //     shop.getProductDetail(productDetailFromApi => {
  //       store.dispatch(storeProductDetail(productDetailFromApi))
  //     })
  //   }
  // }

  getColor = (colors, lang, productColor) => {
    if (colors && lang && productColor) {
      if (colors[lang]) {
        const colorList = productColor.map(pc =>
          colors[lang].find(c => Number(c.value) === Number(pc))
        );
        const color =
          colorList.length > 0 &&
          colorList.reduce((prevVal, elem) => prevVal + ", " + elem.label);
        return color ? color.label : null;
      }
      return null;
    }
  };

  getVideo = video => {
    const videoParams = youtubeVideo(video);
    const opts = {
      height: videoParams[2],
      width: videoParams[1]
    };
    return <YouTube videoId={videoParams[0]} opts={opts} />;
  };

  render() {
    return (
      <div>
        <div className="container">
          <div className="row">
            <div className="col-6">
              <img
                className="align-self-start mr-3 w-100"
                src={productImagePath(
                  this.props.product.image,
                  this.props.product.id
                )}
              />
              {this.props.product.tag && (
                <div className="product__detail__tag">
                  <img
                    src={hostPath(this.props.tags[this.props.product.tag].path)}
                    alt={this.props.tags[this.props.product.tag].name}
                  />
                </div>
              )}
            </div>
            <div className="col-6 product_detail_infos">
              <h4>
                {this.props.translate(
                  "containers.productModalContainer.info_basic"
                )}
              </h4>
              <ul>
                <li>
                  <b>
                    {this.props.translate(
                      "containers.productModalContainer.ean"
                    )}
                    :
                  </b>
                  {this.props.product && this.props.product.ean}
                </li>
                <li>
                  <b>
                    {this.props.translate(
                      "containers.productModalContainer.manufacturer"
                    )}
                    :
                  </b>
                  {/* {this.props.product.manufacturer && this.props.product.manufacturer.find(m=>m.id === this.props.product.manufacturer).name}  */}

                  {this.props.manufacturers &&
                    this.props.manufacturers.length > 0 &&
                    this.props.manufacturers.find(
                      m =>
                        Number(m.value) ===
                        Number(this.props.product.manufacturer)
                    ) &&
                    this.props.manufacturers.find(
                      m =>
                        Number(m.value) ===
                        Number(this.props.product.manufacturer)
                    ).label}
                </li>
                <li>
                  <b>
                    {this.props.translate(
                      "containers.productModalContainer.devices"
                    )}
                    :
                  </b>
                  {this.props.product.compatibility &&
                    this.props.product.compatibility.replace(",", ", ")}
                </li>
                <li>
                  <b>
                    {this.props.translate(
                      "containers.productModalContainer.devices"
                    )}
                    :
                  </b>
                  {this.props.product.devices &&
                    this.props.product.compatibility.find(
                      c => c.id === this.props.product.devices
                    ).name}
                </li>

                <li>
                  <b>
                    {this.props.translate(
                      "containers.productModalContainer.edition"
                    )}
                    :
                  </b>
                  {this.props.product.edition &&
                    this.props.edition &&
                    this.props.edition.length > 0 &&
                    this.props.edition.find(
                      e =>
                        Number(e.value) === Number(this.props.product.edition)
                    ) &&
                    this.props.edition.find(
                      e =>
                        Number(e.value) === Number(this.props.product.edition)
                    ).label}
                </li>
                <li>
                  <b>
                    {this.props.translate(
                      "containers.productModalContainer.color"
                    )}
                    :
                  </b>
                  {this.getColor(
                    this.props.color,
                    this.props.currentLanguage || "gb",
                    this.props.product.color
                  )}
                </li>
                <li>
                  <b>
                    {this.props.translate(
                      "containers.productModalContainer.sku"
                    )}
                    :
                  </b>
                  {this.props.product.code}
                </li>
              </ul>
              <h4>
                {this.props.translate(
                  "containers.productModalContainer.description"
                )}
              </h4>
              {this.props.product.texts && this.props.product.texts.length > 0 && this.props.product.texts[this.props.currentLanguageId] && (
                <p
                  dangerouslySetInnerHTML={createMarkup(
                    this.props.product.texts[this.props.currentLanguageId]
                      .description
                  )}
                />
              )}
              <div>
                <h4>
                  {this.props.translate(
                    "containers.productModalContainer.price"
                  )}
                </h4>
                <br />
                {this.props.product.sale && this.props.product.priceSale ?
                  (<div className="product_detail_price product_detail_price--sale">
                    {parseFloat(this.props.product.priceSale).toFixed(2)} {this.props.currencySign}
                    {this.props.product.priceSale ? (
                      <span className="product_detail_price__old">
                        {parseFloat(this.props.product.price).toFixed(2)} {this.props.currencySign}
                      </span>
                    ) : null}
                  </div>) : (
                    <div className="product_detail_price">
                      {this.props.product &&
                        parseFloat(this.props.product.price).toFixed(2)}{" "}
                      {this.props.currencySign}
                    </div>
                  )}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProductDetailContainer.propTypes = {
  product: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
      ean: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      manufacturer: PropTypes.string.isRequired,
      devices: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      lobing: PropTypes.bool.isRequired,
      description: PropTypes.string.isRequired,
      category: PropTypes.string
    })
  ).isRequired,
  productCartQuantity: PropTypes.number,
  params: PropTypes.shape(),
  isUserLoggedIn: PropTypes.bool,
  toggleModal: PropTypes.func,
  openLobingModal: PropTypes.func,
  translate: PropTypes.func
};

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
  currentLanguageId: getActiveLanguage(state.locale).id,
  currencySign: getCurrencySign(state.common.user.currency.sign),
  manufacturers: state.common.manufacturer,
  edition: state.common.edition,
  color: state.common.color,
  compatibility: state.common.compatibility, tags: state.common.tags
});

const mapDispatchToProps = dispatch => ({
  toggleModal: (modalName, action) => dispatch(toggleModal(modalName, action))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(userIsAuthenticated(ProductDetailContainer));



// WEBPACK FOOTER //
// ./src/routes/ProductDetail/containers/ProductDetailContainer.js